import { createComponent } from '@carvana/merch-components';

export const Heading = createComponent('h3', {
  className: `text-blue-6 tl-header-m m:tl-header-xl`
});

export const Section = createComponent('section', {
  className: `flex w-full flex-col justify-start gap-2xl`
});
